import { CardTypeCallToActions, Learning_Type } from '@app/enums/_index';
import { User } from '@app/models/_index';
import { getEnrollmentMessage } from './enrollment-message.utilities';

/**
 * Get Enrollment status of the enrollment. Used to display in call to action button.
 * @param user - pass user object fetch enrollments
 * @param courseId - course Id of the course
 * @returns enrollment status of the enrollment
 */
export function getEnrollmentStatus(
  user: User,
  courseId: number,
  isFreeCourse: boolean,
  isSubscribed: boolean,
  learningType: string
): string {
  let enrollmentStatus = '';
  if (isFreeCourse || isSubscribed) {
    const enrollment =
      user &&
      user.enrollments &&
      user.enrollments.length > 0 &&
      user.enrollments.find((courseEnrollment) => courseEnrollment.id === courseId);
    if (enrollment) {
      enrollmentStatus = getEnrollmentMessage(enrollment.learningType, enrollment.status);
    } else {
      enrollmentStatus = CardTypeCallToActions.ENROLL;
    }
  } else {
    if (learningType === Learning_Type.E_LEARNING) {
      enrollmentStatus = CardTypeCallToActions.LEARN_MORE;
    } else if (learningType === Learning_Type.CERTIFICATION_EXAM) {
      enrollmentStatus = CardTypeCallToActions.SUBSCRIPTION_REQUIRED;
    } else {
      enrollmentStatus = CardTypeCallToActions.LEARN_MORE;
    }
  }
  return enrollmentStatus;
}
